import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * Only segment: names the area in the breadcrumb, so a group's page reads
 * Gruppi › name. The list and the group's page keep their own screens.
 */
export const Route = createFileRoute('/(private)/(shell)/groups')({
	component: Outlet,
	staticData: { breadcrumb: 'groups:page_title' }
})
